import { formatDate } from '../../../../../shared/LanguageService';
import { eachHourOfInterval, eachMinuteOfInterval } from 'date-fns';
import { BookedEventType } from '../../BookingsCalendarTypes';

enum BusinessHourSpan {
    StartHour = 7,
    EndHour = 24
}

export const resizeBySlotWidth = (resizedWidth, slotPixelWidth, dragItem) => {
    for (let i = 1; i < resizedWidth; i++) {
        if (i % slotPixelWidth === 0) {
            dragItem.style.width = `${i}px`;
        }
    }
};

export const createGhostDragImage = (e, height, width, dragItem) => {
    let dragItemClone = dragItem.cloneNode(true);
    dragItemClone.style.height = height + 'px';
    dragItemClone.style.width = width + 'px';
    document.body.appendChild(dragItemClone);
    e.dataTransfer.setDragImage(dragItemClone, 0, 0);
};

export const createGhostResizeImage = (e, resizeItem) => {
    let resizeImageClone = resizeItem.cloneNode(true);
    resizeImageClone.style.display = 'none';
    document.body.appendChild(resizeImageClone);
    e.dataTransfer.setDragImage(resizeImageClone, 0, 0);
};

export const getBusinessHours = (selectedDate) => {
    let date = new Date(selectedDate);
    let currentYear = Number(formatDate(date, 'yyyy'));
    let currentMonth = Number(formatDate(date, 'MM'));
    let currentDay = Number(formatDate(date, 'dd'));

    return eachHourOfInterval({
        start: new Date(currentYear, currentMonth - 1, currentDay, BusinessHourSpan.StartHour),
        end: new Date(currentYear, currentMonth - 1, currentDay, BusinessHourSpan.EndHour)
    });
};

export const getFiveMinutesSlots = (selectedDate) => {
    let date = new Date(selectedDate);
    let currentYear = Number(formatDate(date, 'yyyy'));
    let currentMonth = Number(formatDate(date, 'MM'));
    let currentDay = Number(formatDate(date, 'dd'));

    return eachMinuteOfInterval(
        {
            start: new Date(currentYear, currentMonth - 1, currentDay, BusinessHourSpan.StartHour),
            end: new Date(currentYear, currentMonth - 1, currentDay, BusinessHourSpan.EndHour)
        },
        { step: 5 }
    );
};

export const getDateTimeFromIndex = (index, fiveMinuteTimeSlots) => {
    let minuteInterval = 5;
    let calendarStartTime = fiveMinuteTimeSlots[0];
    return new Date(calendarStartTime.getTime() + index * minuteInterval * 60 * 1000);
};

export const getSlotIndex = (calendarStartTime, selectedTime) => {
    let minuteIntervalPerHour = 5;
    const msDiff = selectedTime.getTime() - calendarStartTime.getTime();
    return msDiff / (1000 * 60 * minuteIntervalPerHour);
};

export const getBookedEventIndex = (photographer, selectedOrder) => {
    if (photographer && selectedOrder) {
        return photographer.bookedEvents.findIndex(
            (event) => event.orderId === selectedOrder.orderId
        );
    }
    return null;
};

export const getNewStartIndex = (photographer, calendarStartTime, eventType) => {
    if (photographer) {
        let firstEvent = photographer.bookedEvents.find(
            (event, index) => event.type === BookedEventType.travel
        );
        if (eventType === 8 && calendarStartTime && firstEvent) {
            return getSlotIndex(calendarStartTime, new Date(firstEvent.end));
        }
        if (eventType === 0 && calendarStartTime && firstEvent) {
            return getSlotIndex(calendarStartTime, new Date(firstEvent.start));
        }
        if (!firstEvent) {
            let firstEvent = photographer.bookedEvents.find(
                (event) => event.type === BookedEventType.available
            );
            return getSlotIndex(calendarStartTime, new Date(firstEvent.start));
        }
    }
};

export const getLastAvailableSlotIndex = (photographer, calendarStartTime, bookingLength) => {
    let travelEvents = photographer.bookedEvents.filter(
        (event, index) => event.type === BookedEventType.travel
    );
    let lastTravelEvent = travelEvents.length > 0 && travelEvents[travelEvents.length - 1];
    let lastSlotIndex =
        lastTravelEvent && getSlotIndex(calendarStartTime, new Date(lastTravelEvent.start));

    return Math.round(lastSlotIndex - bookingLength + 1);
};

export const getNewLastAvailableSlotIndex = (photographer, calendarStartTime, bookingLength) => {
    let travelEvents = photographer.bookedEvents.filter(
        (event, index) => event.type === BookedEventType.travel
    );
    let lastTravelEvent = travelEvents.length > 0 && travelEvents[travelEvents.length - 1];
    let lastSlotIndex =
        lastTravelEvent && getSlotIndex(calendarStartTime, new Date(lastTravelEvent.start));
    let hiddenLastSlot =
        lastTravelEvent && getSlotIndex(calendarStartTime, new Date(lastTravelEvent.end));
    let diff = hiddenLastSlot - lastSlotIndex;

    return Math.round(diff);
};

export const getWorkHoursForDay = (workingHours, selectedDate) => {
    if (!workingHours || workingHours.length === 0) {
        return null;
    }
    var selectedDayOfWeek = selectedDate.getDay();
    var matchingWorkHours = workingHours.find((workHour) => {
        return workHour.day === selectedDayOfWeek;
    });
    return matchingWorkHours || null;
};

export const isDayClosed = (workingHours, selectedDate) => {
    var workHoursForDay = getWorkHoursForDay(workingHours, selectedDate);
    return !workHoursForDay || !workHoursForDay.isAvailable;
};
